(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fd-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  function linkReviewedProducts(section) {
    const data = section.querySelector('[data-fd-review-products]');
    if (!data) return;
    let products;
    try {
      products = JSON.parse(data.textContent);
    } catch {
      return;
    }
    for (const review of section.querySelectorAll('.jdgm-carousel-item[data-review-id]')) {
      const product = products[review.dataset.reviewId];
      const attribution = review.querySelector('.jdgm-carousel-item__product');
      if (!product || !attribution || !product.title || !product.url?.startsWith('/products/') || attribution.querySelector('.fd-review-product-link')) continue;
      const link = document.createElement('a');
      link.className = 'fd-review-product-link';
      link.href = product.url;
      const image = attribution.querySelector('.jdgm-carousel-item__product-image');
      if (image) link.append(image);
      const title = document.createElement('span');
      title.textContent = product.title;
      link.append(title);
      attribution.append(link);
    }
  }

  function initializeReviewProducts() {
    document.querySelectorAll('.fd-customer-reviews').forEach(linkReviewedProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeReviewProducts, { once: true });
  } else {
    initializeReviewProducts();
  }
  document.addEventListener('shopify:section:load', initializeReviewProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
